import { useMutation, useQueryClient } from '@tanstack/react-query';
import { BASE_URL } from '../../../../../utils/Constants';
import { useAuthStore } from '../../../../../utils/stores/useAuthStore';
import { Message } from '../../../../chat/types/Message';

const sendVenereMessage = async ({
  chatSessionId,
  message,
  sender_id,
  idToken,
}: {
  chatSessionId: string;
  message: string;
  sender_id: string;
  idToken: string;
}) => {
  const response = await fetch(
    `${BASE_URL}/api/chat/sessions/${chatSessionId}/messages`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': idToken,
      },
      body: JSON.stringify({ message, sender_id }),
    },
  );

  if (!response.ok) {
    throw new Error('Failed to send message');
  }

  const data = await response.json();

  return data as Message;
};

export const useVenereSendMessage = (
  chatSessionId: string,
  onComplete?: () => void,
) => {
  const queryClient = useQueryClient();
  const { auth } = useAuthStore();
  const idToken = auth.idToken;

  const { mutate, isPending } = useMutation({
    mutationFn: (message: string) =>
      sendVenereMessage({ 
        chatSessionId, 
        message, 
        sender_id: auth.userId!, 
        idToken: idToken! 
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['venere-messages', chatSessionId] });
      onComplete?.();
    },
  });

  return { sendMessage: mutate, isPending };
}; 